import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) {
    const raw = e?.response?.data;
    if (typeof raw === "string" && raw.trim().startsWith("<")) return "The server could not complete this request. Please try again.";
    return e?.message || "Something went wrong. Please try again.";
  }
  if (typeof detail === "string") {
    if (detail.trim().startsWith("<") || detail.length > 300) return "The server could not complete this request. Please try again.";
    return detail;
  }
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return "Something went wrong. Please try again.";
}

export async function downloadUrl(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export async function downloadFile(fileId, filename) {
  return downloadUrl(`/files/${fileId}/download`, filename);
}

export const STATUS_FLOW = [
  "submitted", "files_under_review", "planning_in_progress", "plan_ready",
  "doctor_review", "revision_requested", "final_delivered", "completed",
];

export const STATUS_LABELS = {
  submitted: "Case Submitted",
  files_under_review: "Files Under Review",
  planning_in_progress: "Planning in Progress",
  plan_ready: "Treatment Plan Ready",
  doctor_review: "Doctor Review",
  revision_requested: "Revision Requested",
  final_delivered: "Final Plan Delivered",
  completed: "Completed",
};

export const STATUS_COLORS = {
  submitted: "bg-slate-100 text-slate-700 border-slate-200",
  files_under_review: "bg-amber-50 text-amber-700 border-amber-200",
  planning_in_progress: "bg-blue-50 text-blue-700 border-blue-200",
  plan_ready: "bg-violet-50 text-violet-700 border-violet-200",
  doctor_review: "bg-cyan-50 text-cyan-700 border-cyan-200",
  revision_requested: "bg-red-50 text-red-700 border-red-200",
  final_delivered: "bg-emerald-50 text-emerald-700 border-emerald-200",
  completed: "bg-emerald-600 text-white border-emerald-600",
};

export default api;
